<template>
  <div>
    <div class="p-uploader__preview d-flex align-items-center cursor-pointer">
      <div :class="['p-uploader__media-wrapper', iconSize]" @click.stop="openModal">
        <template v-if="isImage">
          <img class="p-uploader__img" :class="{'cursor-default': !viewFile}" ref="img" :src="file.url" alt="" @load="onLoadImage">
        </template>
        <template v-else-if="isVideo">
          <video controls class="p-uploader__video">
            <source :src="fileUrl">
            Your browser does not support HTML5 video.
          </video>
        </template>
        <template v-else>
          Invalid
        </template>
      </div>
      <div class="p-uploader__info">
        <div class="p-uploader__file-name" :title="file.name">{{ file.name|truncate(truncateChar, '...') }}</div>
        <div class="p-uploader__file-size text-help" v-if="showFileAttrs">
          <template v-if="isImage">{{ file.size|formatSize }}</template>
          <template v-else-if="isVideo">{{ file.size|formatDuration }}</template>
          <template v-if="getImgSizes()"> | {{getImgSizes()}}</template>
        </div>
      </div>
    </div>

    <CModal :show.sync="showModal" size="lg" centered>
      <template v-if="isImage">
        <img class="modal-preview-image" :src="file.url" alt="">
      </template>
      <template v-else-if="isVideo">
        <video controls class="p-uploader__video">
          <source :src="file.url">
          Your browser does not support HTML5 video.
        </video>
      </template>
      <template #footer>
          <CButton size="sm" @click.stop="showModal=false" color="primary" v-translate>Close</CButton>
        </template>
    </CModal>
  </div>
</template>
<script>
import fileUtils from "@/domain/core/utils/fileUtils";

export default {
  name: "Preview",
  emit: ['delete', 'loadImage'],
  props: {
    file: {
      type: File,
      required: true
    },
    showFileAttrs: {
      type: Boolean,
      default: false
    },
    truncateChar: {
      type: Number,
      default: 50
    },
    viewFile: {
      type: Boolean,
      default: true
    },
    iconSize: {
      type: String,
      required: false,
      validator: function (value) {
        return ['compact', 'landscape'].includes(value)
      }
    }
  },
  data() {
    return {
      showModal: false
    }
  },
  computed: {
    isImage() {
      return fileUtils.isImage(this.file)
    },
    isVideo() {
      return fileUtils.isVideo(this.file)
    },
    fileUrl() {
      if (!this.isImage && !this.isVideo) return null
      return this.file
    }
  },
  methods: {
    openModal() {
      if (!this.isImage && !this.isVideo || !this.viewFile)
        return
      this.showModal = true
    },
    onLoadImage(e) {
      this.$emit('loadImage', {img: e.currentTarget, file: this.file})
    },
    getImgSizes() {
      if (!this.isImage) return null
      if (!this.$refs.img) return null // Refs are not available until the component is mounted
      return `${this.$refs.img.naturalWidth}x${this.$refs.img.naturalHeight} px`
    }
  }
}
</script>